import { render, staticRenderFns } from "./template.html?vue&type=template&id=c28727a2&scoped=true&external"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=c28727a2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28727a2",
  null
  
)

export default component.exports